// extracted by mini-css-extract-plugin
export default {"root":"content-grid_root__Al86O","grid":"content-grid_grid__Fvdqk"};